module.exports = __webpack_public_path__ + "static/media/no-file.19b05f6a.svg";